export default {
    DarkBlue: '#2B63A9',
    Blue: '#366DB4',
    LightBlue: '#8ED4FD',
    Yellow: '#F2EA79',
    Pink: '#E94B91',
    Green: '#3ED58F',
    LimeGreen: '#C3DA40',
    LightGray: '#FFFFFF7F',
    White: '#FFFFFF',
    Black: '#000000'
}
